/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerFindAllQueryResponse, ApplicationsControllerFindAllQueryParams, ApplicationsControllerFindAll401, ApplicationsControllerFindAll403 } from "../../models/checklistsController/ApplicationsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationsControllerFindAll } from "../../clients/checklistsService/applicationsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationsControllerFindAllQueryKey = (params: ApplicationsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-applications'
}, ...(params ? [params] : [])] as const;
export type ApplicationsControllerFindAllQueryKey = ReturnType<typeof applicationsControllerFindAllQueryKey>;
export function applicationsControllerFindAllQueryOptions(params?: ApplicationsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationsControllerFindAllQueryKey(params);
  return queryOptions<ApplicationsControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationsControllerFindAll401 | ApplicationsControllerFindAll403>, ApplicationsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationsControllerFindAll(params, config);
    }
  });
}

/**
 * @description Retrieve checklist applications with optional filtering by resource. Use `resourceId` and `resourceType` together to filter applications whose scope collection contains a scope that owns the specified resource (e.g., a specific File or Project). Example: `?resourceId=clh123&resourceType=FILE` returns applications applied to that file.
 * @summary Get all checklist applications
 * {@link /api/v1/checklist-applications}
 */
export function useApplicationsControllerFindAll<TData = ApplicationsControllerFindAllQueryResponse, TQueryData = ApplicationsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ApplicationsControllerFindAllQueryKey>(params?: ApplicationsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationsControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationsControllerFindAll401 | ApplicationsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...applicationsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationsControllerFindAll401 | ApplicationsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}